import { ChangeDetectionStrategy, Component, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentSitemapComponent } from '../../widget-content/sitemap/sitemap.component';

@Component({
    selector: 'fi-widget-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-sitemap' },
    standalone: false,
})
export class WidgetSitemapComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentSitemapComponent, { static: false }) sitemapContent: WidgetContentSitemapComponent;

    get isEmpty$() {
        return this.sitemapContent.isEmpty$;
    }
}
